// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__blvrc","options":"AnswerScale_options__VKmyz","selected":"AnswerScale_selected__1zk3s"};